import { Button } from '@/components/ui/button.tsx';

export function EmptyBenefitsState({
  onChooseDifferentSupplies,
}: {
  onChooseDifferentSupplies: () => void;
}) {
  return (
    <div className="border-charcoal-200 flex flex-col items-center rounded-lg border bg-white p-6 text-center">
      <p className="text-base font-medium text-charcoal-900">
        No matching supplies found for your selected categories.
      </p>
      <p className="text-charcoal-600 mt-2 text-sm leading-snug">
        We could not find eligible supplies in the categories you selected.
      </p>

      <Button
        className="mt-4 px-0"
        variant="link"
        size="sm"
        type="button"
        onClick={onChooseDifferentSupplies}
      >
        Choose different supply categories
      </Button>
    </div>
  );
}
